import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as settings from "../../../constants/settings";
import * as itemTypes from "../../../constants/itemTypes";
import * as rccActions from "../../../actions/rccActions";
import * as barcodeActions from "../../../actions/barcodeActions";
import * as batchActions from "../../../actions/batchActions";
import * as navigationActions from "../../../actions/navigationActions";
import * as formatHelper from "../../../helpers/formatHelper";
import * as validationHelper from "../../../helpers/validationHelper";
import * as batchStatuses from "../../../constants/batchStatuses";
import * as modelHelper from "../../../helpers/modelHelper";

import imgOk from "../../../resources/img/svgicons/confirm.svg";

import CancelButton from "../generic/CancelButton";
import Button from "../generic/Button";
import Modal from "../generic/Modal";

class RefillConfirmationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canister: null,
            level: 0,
            ufiCode: "",
            isUfiCodeValid: false,
            barcodeUfi: null,
            barcodeReset: false,
            batchNumber: "",
            batchNumberProductionDate: null,
            barcodeBatchNumber: null,
            batchNumberStatus: batchStatuses.BATCH_STATUS_VALID
        };
    }

    getCanisterById = (id) => {
        for (let canister of this.props.canisterList) {
            if (canister.id === id) {
                return canister;
            }
        }

        return null;
    };

    componentDidMount = () => {
        if (
            this.props.params !== undefined &&
            this.props.params.index !== undefined &&
            this.props.params.level !== undefined
        ) {
            let activeCanister = this.getCanisterById(this.props.params.index);

            if (activeCanister !== null) {
                this.setState({
                    canister: activeCanister,
                    level: this.props.params.level,
                    ufiCode: activeCanister.ufi === null ? "" : activeCanister.ufi,
                    isUfiCodeValid: validationHelper.isUfiCodeValid(activeCanister.ufi),
                    barcodeUfi: null,
                    barcodeReset: false
                });

                if (this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED) {
                    this.props.dispatchGetBatchesByColorantAction(activeCanister.colorant.id);
                }
            }
        }
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.barcodeType === itemTypes.UFI_CODE && nextProps.barcode !== prevState.barcodeUfi) {
            if (prevState.barcodeReset) {
                return {barcodeReset: false};
            }

            return {
                ufiCode: nextProps.barcode,
                isUfiCodeValid: validationHelper.isUfiCodeValid(nextProps.barcode),
                barcodeUfi: nextProps.barcode
            };
        }

        if (
            nextProps.barcodeType === itemTypes.COLORANT_BATCH_NUMBER &&
            nextProps.barcode !== prevState.barcodeBatchNumber
        ) {
            if (prevState.barcodeReset) {
                return {barcodeReset: false};
            }

            return {
                batchNumber: nextProps.barcode.batchNumber,
                batchNumberStatus: nextProps.barcode.statusId,
                batchNumberProductionDate: nextProps.barcode.productionDate,
                barcodeBatchNumber: nextProps.barcode
            };
        }

        return null;
    }

    updateCanisterLevel = () => {
        this.props.dispatchRefillCanisterAction(
            this.state.canister.id,
            this.state.level,
            this.props.params.add,
            this.props.params.unitMl,
            this.state.ufiCode,
            this.state.batchNumber,
            this.props.params.type
        );
    };

    isConfirmBtnDisabled = () => {
        if (this.props.params.add && this.state.level <= 0) {
            return true;
        }

        if (!this.props.params.add) {
            if (this.state.level < this.state.canister.currentLevel) {
                return false;
            }

            if (this.state.level > this.state.canister.capacity) {
                return true;
            }
        }

        if (this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED) {
            if (
                this.state.batchNumberStatus === batchStatuses.BATCH_STATUS_INVALID ||
                this.state.batchNumber === null ||
                this.state.batchNumber.trim().length === 0
            ) {
                return true;
            }
        }

        if (
            this.props.ufiCodeLogic === settings.UFI_CODE_LOGIC_DISABLED ||
            this.props.ufiCodeLogic === settings.UFI_CODE_LOGIC_DB_VALUES
        ) {
            return false;
        }

        return !this.state.isUfiCodeValid;
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleUfiCodeChange = (event) => {
        if (event.target.value.length < 20) {
            if (this.state.barcodeUfi !== null) {
                this.setState(
                    {
                        ufiCode: event.target.value,
                        isUfiCodeValid: validationHelper.isUfiCodeValid(event.target.value),
                        barcodeUfi: null,
                        barcodeReset: true
                    },
                    this.props.dispatchResetBarcodeAction
                );
            } else {
                this.setState({
                    ufiCode: event.target.value,
                    isUfiCodeValid: validationHelper.isUfiCodeValid(event.target.value)
                });
            }
        }
    };

    handleBatchNumberChange = (event) => {
        const matchedBatch = this.props.batchesByColorant.find((batch) => batch.batchNumber === event.target.value);
        this.setState({
            batchNumber: event.target.value,
            batchNumberStatus: matchedBatch ? matchedBatch.statusId : batchStatuses.BATCH_STATUS_VALID,
            batchNumberProductionDate: matchedBatch ? matchedBatch.productionDate : null
        });
    };

    handleConfirmClick = () => {
        this.updateCanisterLevel();
    };

    getFinalLevel = () => {
        if (this.props.params.add === true) {
            if (this.props.params.unitMl) {
                let filling = this.state.level;

                if (this.props.rccUnit !== settings.UNIT_ML) {
                    filling = filling * this.state.canister.unitCoefficient;
                }

                return (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-xs-4">
                                <Translate value="canistersTab.fillingAmount" />:
                            </div>
                            <div className="col-xs-8 color-primary">
                                {formatHelper.formatDecimal(filling)}&nbsp;{this.props.rccUnit}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4">
                                <Translate value="canistersTab.finalLevel" />:
                            </div>
                            <div className="col-xs-8 color-primary">
                                {formatHelper.formatDecimal(this.state.canister.currentLevel + filling)}&nbsp;
                                {this.props.rccUnit}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }

            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-xs-4">
                            <Translate value="canistersTab.fillingAmount" />:
                        </div>
                        <div className="col-xs-8 color-primary">
                            {formatHelper.formatDecimal(this.state.level)}&nbsp;{this.props.rccUnit}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-4">
                            <Translate value="canistersTab.finalLevel" />:
                        </div>
                        <div className="col-xs-8 color-primary">
                            {formatHelper.formatDecimal(this.state.canister.currentLevel + this.state.level)}&nbsp;
                            {this.props.rccUnit}
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        if (this.props.params.unitMl) {
            return "";
        }

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-4">
                        <Translate value="canistersTab.fillingAmount" />:
                    </div>
                    <div className="col-xs-8 color-primary">
                        {formatHelper.formatDecimal(this.state.level - this.state.canister.currentLevel)}&nbsp;
                        {this.props.rccUnit}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <Translate value="canistersTab.finalLevel" />:
                    </div>
                    <div className="col-xs-8 color-primary">
                        {formatHelper.formatDecimal(this.state.level)}&nbsp;{this.props.rccUnit}
                    </div>
                </div>
            </React.Fragment>
        );
    };

    getUfiCodeInput = () => {
        if (
            (this.props.params.add === false && this.state.level - this.state.canister.currentLevel < 0) ||
            this.props.ufiCodeLogic === settings.UFI_CODE_LOGIC_DISABLED ||
            this.props.ufiCodeLogic === settings.UFI_CODE_LOGIC_DB_VALUES
        ) {
            return "";
        }

        if (this.state.isUfiCodeValid) {
            return (
                <div className="dialog-messages messages-success">
                    <div className="group">
                        <span className="glyphicon glyphicon-ok-sign" />
                        <Translate value="ufiCodeSettings.scanOrTypeUfiCode" />
                    </div>
                    <div className="input-group">
                        <input
                            type="text"
                            value={this.state.ufiCode}
                            onFocus={this.handleInputFocus}
                            onChange={this.handleUfiCodeChange}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="dialog-messages messages-warning">
                <Translate value="ufiCodeSettings.scanOrTypeUfiCode" />
                <div className="input-group">
                    <input
                        type="text"
                        value={this.state.ufiCode}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleUfiCodeChange}
                    />
                </div>
            </div>
        );
    };

    getBatchNumberBackgroundClass = () => {
        if (this.state.batchNumber === "") {
            return "messages-warning";
        }
        switch (this.state.batchNumberStatus) {
            case batchStatuses.BATCH_STATUS_VALID:
                return "messages-success";
            case batchStatuses.BATCH_STATUS_WARNING:
                return "messages-warning";
            case batchStatuses.BATCH_STATUS_INVALID:
                return "bg-danger";
        }

        return "messages-warning";
    };

    getBatchNumberIcon = () => {
        if (this.state.batchNumber === "") {
            return "";
        }
        switch (this.state.batchNumberStatus) {
            case batchStatuses.BATCH_STATUS_VALID:
                return <span className="glyphicon glyphicon-ok-sign" />;
            case batchStatuses.BATCH_STATUS_WARNING:
                return <span className="glyphicon glyphicon-exclamation-sign" />;
            case batchStatuses.BATCH_STATUS_INVALID:
                return <span className="glyphicon glyphicon-remove-sign" />;
        }

        return "";
    };

    getBatchNumberText = () => {
        if (this.state.batchNumber === "") {
            return <Translate value="colorantBatchNumberSettings.scanOrTypeBatchNumber" />;
        }
        switch (this.state.batchNumberStatus) {
            case batchStatuses.BATCH_STATUS_VALID:
                return <Translate value="colorantBatchNumberSettings.scanOrTypeBatchNumber" />;
            case batchStatuses.BATCH_STATUS_WARNING:
                return <Translate value="colorantBatchNumberSettings.possibleDamagedBatchOfColorant" />;
            case batchStatuses.BATCH_STATUS_INVALID:
                return <Translate value="colorantBatchNumberSettings.defectiveBatchOfColorant" />;
        }

        return <Translate value="colorantBatchNumberSettings.scanOrTypeBatchNumber" />;
    };

    getBatchNumberProductionDate = () => {
        if (this.state.batchNumberProductionDate) {
            return (
                <div>
                    <Translate value="general.creationDateOf" />
                    &nbsp;
                    <Translate value="general.batchNumber" />
                    :&nbsp;{formatHelper.formatDate(this.state.batchNumberProductionDate)}
                </div>
            );
        }

        return "";
    };

    getBatchNumberInput = () => {
        if (
            (this.props.params.add === false && this.state.level - this.state.canister.currentLevel < 0) ||
            this.props.colorantBatchNumberLogic === settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED
        ) {
            return "";
        }

        return (
            <div className={"dialog-messages " + this.getBatchNumberBackgroundClass()}>
                <div className="group">
                    {this.getBatchNumberIcon()}
                    &nbsp;
                    {this.getBatchNumberText()}
                </div>
                <div className="input-group">
                    <input
                        type="text"
                        value={this.state.batchNumber}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleBatchNumberChange}
                    />
                </div>
                {this.getBatchNumberProductionDate()}
            </div>
        );
    };

    getContent = () => {
        if (this.state.canister === null || this.state.canister.colorant === null) {
            return modelHelper.buildModalSection("");
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-4">
                        <Translate value="general.canister" />:
                    </div>
                    <div className="col-xs-8 color-primary">{this.state.canister.id}</div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <Translate value="general.colorant" />:
                    </div>
                    <div className="col-xs-8 color-primary">{this.state.canister.colorant.name}</div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <Translate value="general.actualLevel" />:
                    </div>
                    <div className="col-xs-8 color-primary">
                        {formatHelper.formatDecimal(this.state.canister.currentLevel)}&nbsp;{this.props.rccUnit}
                    </div>
                </div>
                {this.getFinalLevel()}
                {this.getUfiCodeInput()}
                {this.getBatchNumberInput()}
            </React.Fragment>,
            "flex-column flex-row-gap-10px"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.state.canister !== null && this.state.canister.colorant !== null && (
                    <Button
                        onClick={this.handleConfirmClick}
                        svgBefore={imgOk}
                        label={translate("general.confirm")}
                        disabled={this.isConfirmBtnDisabled()}
                    />
                )}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("ufiCodeSettings.confirmColorantRefilling"))}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        ufiCodeLogic: store.settings.ufiCodeLogic,
        colorantBatchNumberLogic: store.settings.colorantBatchNumberLogic,
        rccUnit:
            store.rcc.machineConfigurationList === null ? settings.UNIT_ML : store.rcc.machineConfigurationList.unit,
        barcode: store.barcode.item,
        barcodeType: store.barcode.itemType,
        canisterList: store.rcc.canisterList,
        batchesByColorant: store.machine.batchesByColorant
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchRefillCanisterAction: (index, level, add, unitMl, ufiCode, batchNumber, type) => {
            dispatch(rccActions.refillCanister(index, level, add, unitMl, ufiCode, batchNumber, type));
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.REFILL_CONFIRMATION_MODAL));
        },
        dispatchResetBarcodeAction: () => {
            dispatch(barcodeActions.resetBarcode());
        },
        dispatchGetBatchesByColorantAction: (colorantId) => {
            dispatch(batchActions.getBatchesByColorant(colorantId));
        }
    };
};

export default RefillConfirmationModal = connect(mapStoreToProps, mapDispatchToProps)(RefillConfirmationModal);
